module.exports = __webpack_public_path__ + "img/how-it-works-4.136b4511.jpg";